<template>
  <div class="text-center">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab small v-bind="attrs" v-on="on"> <v-icon>mdi-web</v-icon> </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-title @click="handleSetLanguage('th')" value="th">ภาษาไทย</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title @click="handleSetLanguage('en')" value="en">English</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
      // this.$message({
      //   message: 'Switch Language Success',
      //   type: 'success'
      // })
    }
  }
}
</script>
